import type { Components } from '@mui/material/styles';

export default function MUIDialogContentText(): Components['MuiDialogContentText'] {
  return {};
}
